export const mediaCSS = (px: number) => `@media (max-width: ${px}px)`;

export const extraLarge = () => "(max-width: 1200px)";
export const large = () => "(max-width: 1024px)";
export const medium = () => "(max-width: 996px)";
export const small = () => "(max-width: 600px)";
